import { __read, __spreadArray } from "tslib";
import { isFunction } from '@antv/util';
export function getCallbackValue(value, params) {
  return isFunction(value) ? value.apply(void 0, __spreadArray([], __read(params), false)) : value;
}